<div class="ant-skeleton-content">
  <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
  <h3 class="ant-skeleton-title"></h3>
</div>
